module.exports = __webpack_public_path__ + "img/sc-gallery-1.f4867999.jpg";